// import Proj1 from "../assets/proj1.jpg";
import Proj1 from '../assets/projects/Proj1.PNG'
import Proj2 from '../assets/projects/Proj2.PNG'
import Proj3 from '../assets/projects/Proj3.PNG'
import Proj4 from '../assets/projects/Proj4.PNG'
import Proj5 from '../assets/projects/Proj5.PNG'
import Proj6 from '../assets/projects/Proj6.PNG'
import Proj7 from '../assets/projects/Proj7.PNG'
import Proj8 from '../assets/projects/Proj8.PNG'
import Proj9 from '../assets/projects/Proj9.webp'
import Proj10 from '../assets/projects/Proj10.PNG'
import Proj11 from '../assets/projects/Proj11.PNG'
import Proj12 from '../assets/projects/proj12.PNG'









export const ProjectList = [
  {
    name: "Netflix-Clone",
    image: Proj12,
    skills: "Reactjs,JavaScript,HTML,CSS",
    url:'https://netflix-clone-vert-chi-82.vercel.app/',
    github:'https://github.com/xayyeem/Netflix-Clone'
  },
  {
    name: "CryptoPulse",
    image: Proj1,
    skills: "Reactjs,JavaScript,HTML,CSS",
    url:'https://teal-kataifi-d71b65.netlify.app/',
    github:'https://github.com/xayyeem/cryptopulse'
  },
  {
    name: "Speech-To-Text-Convertor",
    image: Proj11,
    skills: "Reactjs,JavaScript,HTML,CSS",
    url:'https://speechtotext-sigma.vercel.app/',
    github:'https://github.com/xayyeem/speechtotext'
  },
  {
    name: "VirtualX",
    image: Proj2,
    skills: "Reactjs,TailwindCss,JavaScript,HTML",
    url:'https://virtual-x.vercel.app/',
    github:'https://github.com/xayyeem/virtualx'
  },
  {
    name: "CelesTech",
    image: Proj3,
    skills: "React,Scss,MaterialUI",
    url:'https://celesteck.netlify.app/',
    github:'https://github.com/xayyeem/CelesTech'
  },
  {
    name: "WonderLust Trip",
    image: Proj4,
    skills: "React,JavaScript,HTML,CSS",
    url:'https://wonder-lust-trip.vercel.app/',
    github:'https://github.com/xayyeem/WonderLustTrip'
  },
  {
    name: "Disney+ Hotstar Clone",
    image: Proj6,
    skills: "HTML,CSS,BootStrap",
    url:'https://fancy-alpaca-97f77c.netlify.app/',
    github:'https://github.com/xayyeem/disney-clone/tree/main/Disney%2B%20clone'
  },
  {
    name: "Weather App",
    image: Proj10,
    skills: "JavaScript,HTML,CSS",
    url:'https://cheery-concha-0b28c7.netlify.app/',
    github:'https://github.com/xayyeem/Weather-app/tree/main/weather%20app'
  },
  {
    name: "Random Password Generator",
    image: Proj9,
    skills: "React,JavaScript,HTML,CSS",
    url:'https://willowy-phoenix-2f8cb3.netlify.app/',
    github:'https://github.com/xayyeem/Random-password-generator/tree/main/random%20password%20generator'
  },
  {
    name: "Random Meme Generator",
    image: Proj8,
    skills: "React,JavaScript,HTML,CSS",
    url:'https://meme-generator-chi-cyan.vercel.app/',
    github:'https://github.com/xayyeem/meme-generator'
  },
  {
    name: "Random Tweet Generator",
    image: Proj7,
    skills: "React,JavaScript,HTML,CSS",
    url:'https://meme-generator-chi-cyan.vercel.app/',
    github:'https://github.com/xayyeem/meme-generator'
  },
  {
    name: "Khalid Portfolio-Card",
    image: Proj5,
    skills: "JavaScript,HTML,CSS",
    url:'https://portfolio-card-mu.vercel.app/',
    github:'https://github.com/xayyeem/Portfolio-card'
  },
];
